class FooterElement extends Collapsible {
  constructor() {
    super();
    this.klaviyoPopup();
  }

  klaviyoPopup() {
    this.querySelectorAll('.klaviyo-trigger').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const id =
          window.innerWidth < 768 ? trigger.dataset.triggerMobile : trigger.dataset.triggerDesktop;
        if (!id) {
          return;
        }
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
      });
    });
  }
}

if (!customElements.get('footer-element')) {
  customElements.define('footer-element', FooterElement);
}
